import React from "react";
import { DocumentEditor } from "../DocumentEditor";
import { DocumentEditorToolbar } from "../DocumentEditorToolbar";
import { DocumentEditorWrapper } from "../DocumentEditorWrapper";
export var DocumentEditorView = function(param) {
    var builder = param.builder, _toolbarOptions = param.toolbarOptions, toolbarOptions = _toolbarOptions === void 0 ? {} : _toolbarOptions;
    return /*#__PURE__*/ React.createElement("div", {
        id: "DocumentEditView"
    }, /*#__PURE__*/ React.createElement(DocumentEditorWrapper, {
        builder: builder
    }, /*#__PURE__*/ React.createElement(DocumentEditorToolbar, {
        enableChangeLog: true,
        options: toolbarOptions
    }), /*#__PURE__*/ React.createElement(DocumentEditor, null)));
};
